import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { NgIf, NgFor } from '@angular/common';
import { SoftwareService } from '../../../../core/services/software.service';

@Component({
  selector: 'app-software-line',
  standalone: true,
  imports: [NgIf, NgFor, RouterLink],
  templateUrl: './line.component.html',
  styleUrl: './line.component.scss'
})
export class LineComponent {
  private route = inject(ActivatedRoute);
  private ss = inject(SoftwareService);
  slug = this.route.snapshot.paramMap.get('line') as 'lis'|'blood-bank'|'vet-lis';
  line = this.ss.getLine(this.slug);
  versions = this.ss.getVersions(this.slug);
}
